import type { ReactNode } from 'react';
import { BRAND } from '../config/brand';
import { useDocumentTitle } from '../lib/useDocumentTitle';
import { Wordmark } from './Logo';

interface Props {
  /** Browser-tab title for this auth screen (e.g. "Log in", "Sign up"). */
  title?: string;
  children: ReactNode;
}

export function AuthLayout({ title, children }: Props) {
  // Each auth page passes a title so the browser tab / screen reader / AI
  // agent can tell Log in / Sign up / Reset password / Accept invite apart.
  useDocumentTitle(title);

  return (
    <div className="auth-shell">
      <div className="brand-mark">
        <Wordmark size={56} />
      </div>
      <p className="brand-tag">{BRAND.tagline}</p>
      <div className="auth-card">{children}</div>
    </div>
  );
}
